module.exports = __webpack_public_path__ + "static/img/03bg@2x.403892a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/03bg@2x.png
// module id = FOpH
// module chunks = 1